import React, { useState } from "react";
import AppList from "./AppList";
import AppForm from "./AppForm";

const AppIndex = () => {
  const [view, setView] = useState("list");
  const [selectedApp, setSelectedApp] = useState(null);

  const handleAdd = () => {
    setSelectedApp(null);
    setView("add");
  };

  const handleEdit = (app) => {
    setSelectedApp(app);
    setView("edit");
  };

  const handleBack = () => {
    setSelectedApp(null);
    setView("list");
  };

  if (view === "add" || view === "edit") {
    return (
      <AppForm
        mode={view}
        appData={selectedApp}
        onBack={handleBack}
      />
    );
  }

  return <AppList onAdd={handleAdd} onEdit={handleEdit} />;
};

export default AppIndex;